import { render } from "./Debug.vue?vue&type=template&id=6452a808"
import script from "./Debug.vue?vue&type=script&lang=ts"
export * from "./Debug.vue?vue&type=script&lang=ts"
script.render = render

export default script